import { useCallback } from 'react';
import { clamp } from 'lodash';
import { SliderProps } from '../Slider';
import { add } from 'lodash/fp';

type Props = SliderProps & {
    currentValue: number;
    setCurrentValue: (currentValue: number) => void;
};

const useSliderButtonsEventHandlers = (
    props: Props,
): {
    incrementButtonClick: () => void;
    decrementButtonClick: () => void;
} => {
    const { min, max, currentValue, setCurrentValue, incrementValue = add(1), decrementValue = add(-1) } = props;

    const incrementButtonClick = useCallback(() => {
        const newValue = incrementValue(currentValue);
        const newClampedValue = clamp(newValue, min, max);

        if (newClampedValue === currentValue) return;

        setCurrentValue(newClampedValue);
    }, [currentValue, min, max]);

    const decrementButtonClick = useCallback(() => {
        const newValue = decrementValue(currentValue);
        const newClampedValue = clamp(newValue, min, max);

        if (newClampedValue === currentValue) return;

        setCurrentValue(newClampedValue);
    }, [currentValue, min, max]);

    return {
        incrementButtonClick,
        decrementButtonClick,
    };
};

export default useSliderButtonsEventHandlers;
